require('./runtime');
"use strict";
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./context"), require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./context", "./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./context"), require("./utils")) : factory(root["./context"], root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(globalThis, (__WEBPACK_EXTERNAL_MODULE__14935__, __WEBPACK_EXTERNAL_MODULE__78815__) => {
return (globalThis["wpBaUiCarbonToolkit"] = globalThis["wpBaUiCarbonToolkit"] || []).push([[5921],{

/***/ 80842:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {



var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
var _withDragLayer = _interopRequireDefault(__webpack_require__(2253));
exports.withDragLayer = _withDragLayer.default;
exports["default"] = _withDragLayer.default;

/***/ }),

/***/ 2253:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {



var _interopRequireDefault = __webpack_require__(97880);
exports.__esModule = true;
exports.DragLayer = void 0;
exports["default"] = withDragLayer;
var _extends2 = _interopRequireDefault(__webpack_require__(38213));
var _defineProperty2 = _interopRequireDefault(__webpack_require__(68779));
var _react = _interopRequireWildcard(__webpack_require__(16689));
var _propTypes = _interopRequireDefault(__webpack_require__(580));
var _reactDom = _interopRequireDefault(__webpack_require__(66405));
var _reactDnd = __webpack_require__(47964);
var _context = __webpack_require__(14935);
var _utils = __webpack_require__(78815);
var _dec, _class, _class2;
/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-toolkit
 * (C) Copyright IBM Corp. 2019
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const {
  omit
} = _utils.lodash;
let DragLayer = exports.DragLayer = (_dec = (0, _reactDnd.DragLayer)(monitor => ({
  item: monitor.getItem(),
  currentOffset: monitor.getClientOffset(),
  isDragging: monitor.isDragging(),
  canDrop: () => monitor.isDragging() && monitor.getTargetIds().some(targetId => monitor.isOverTarget(targetId) && monitor.canDropOnTarget(targetId))
})), _dec(_class = (_class2 = class DragLayer extends _react.Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.isDragging && !this.props.isDragging) {
      nextProps.onBeginDrag();
    } else if (!nextProps.isDragging && this.props.isDragging) {
      nextProps.onEndDrag();
    }
  }
  render() {
    const {
      currentOffset,
      item,
      isDragging,
      canDrop
    } = this.props;
    if (!currentOffset || !item || !isDragging || !item.dragLayerRenderer) {
      return null;
    }
    return item.dragLayerRenderer({
      itemProps: item,
      droppable: canDrop(),
      currentOffset
    });
  }
}, (0, _defineProperty2.default)(_class2, "propTypes", {
  item: _propTypes.default.object,
  isDragging: _propTypes.default.bool.isRequired,
  currentOffset: _propTypes.default.object,
  onBeginDrag: _propTypes.default.func.isRequired,
  onEndDrag: _propTypes.default.func.isRequired,
  canDrop: _propTypes.default.func.isRequired
}), _class2)) || _class);
function withDragLayer(WrappedComponent) {
  var _dec2, _class3, _class4;
  let WithDragLayer = (_dec2 = (0, _context.withContext)('theme'), _dec2(_class3 = (_class4 = class WithDragLayer extends _react.Component {
    constructor() {
      super(...arguments);
      (0, _defineProperty2.default)(this, "_onBeginDrag", () => {
        this._dragLayerContainer.hidden = false;
      });
      (0, _defineProperty2.default)(this, "_onEndDrag", () => {
        this._dragLayerContainer.hidden = true;
      });
    }
    componentWillMount() {
      const dragLayerContainer = document.createElement('div');
      dragLayerContainer.hidden = true;
      document.body.appendChild(dragLayerContainer);
      this._dragLayerContainer = dragLayerContainer;
    }
    componentWillUnmount() {
      if (this._dragLayerContainer) {
        _reactDom.default.unmountComponentAtNode(this._dragLayerContainer);
        this._dragLayerContainer.parentNode.removeChild(this._dragLayerContainer);
        this._dragLayerContainer = null;
      }
    }
    render() {
      const {
        dragLayerForwardRef,
        ...other
      } = this.props;
      const passThroughProps = omit(other, 'theme');
      return [/*#__PURE__*/_react.default.createElement(WrappedComponent, (0, _extends2.default)({
        key: "0"
      }, passThroughProps, {
        ref: dragLayerForwardRef
      })), _reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement(DragLayer, {
        onBeginDrag: this._onBeginDrag,
        onEndDrag: this._onEndDrag
      }), this._dragLayerContainer)];
    }
  }, (0, _defineProperty2.default)(_class4, "propTypes", {
    theme: _propTypes.default.string,
    dragLayerForwardRef: _propTypes.default.any
  }), _class4)) || _class3);
  return _react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(WithDragLayer, (0, _extends2.default)({}, props, {
    dragLayerForwardRef: ref
  })));
}

/***/ }),

/***/ 68779:
/***/ ((module) => {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 38213:
/***/ ((module) => {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 97880:
/***/ ((module) => {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 580:
/***/ ((module) => {

module.exports = require("prop-types");

/***/ }),

/***/ 16689:
/***/ ((module) => {

module.exports = require("react");

/***/ }),

/***/ 47964:
/***/ ((module) => {

module.exports = require("react-dnd");

/***/ }),

/***/ 66405:
/***/ ((module) => {

module.exports = require("react-dom");

/***/ }),

/***/ 14935:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__14935__;

/***/ }),

/***/ 78815:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__78815__;

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__(80842));
/******/ return __webpack_exports__;
/******/ }
]);
});